import { space } from "@smartsheet/design-tokens";
import { color } from "@smartsheet/design-tokens-react";
import { themed } from "@smartsheet/sds-theme-internal";
import { neutralDark40, neutralLight40 } from "../../../constants/colors";
import { shadows } from "../../../constants/layers";
import { sizes } from "../../../constants/spacing";
export var modalTheme = themed({
  actionsPadding: {
    "lodestar-light": "".concat(sizes.small, "px ").concat(sizes.small, "px 0"),
    "ursa-light": "".concat(space.space50, " ").concat(space.space50, " 0")
  },
  backgroundColor: {
    "lodestar-light": neutralLight40,
    "ursa-light": color("surface--work--background")
  },
  boxShadow: {
    // TODO use the official elevation color tokens for this at some point.
    "lodestar-light": "".concat(shadows.modal()),
    "ursa-light": "0px 2px 4px rgba(57, 61, 76, 0.12), 0px 12px 24px 8px rgba(65, 80, 139, 0.2)"
  },
  bodyGutter: {
    "lodestar-light": "legacy",
    "ursa-light": "space60"
  },
  borderRadius: {
    "lodestar-light": "0px",
    "ursa-light": space.space30
  },
  color: {
    "lodestar-light": neutralDark40,
    "ursa-light": color("surface--work--text")
  }
});
export function getActionsPadding(_ref) {
  var themeMode = _ref.themeMode;
  return modalTheme.actionsPadding(themeMode);
}
export function getBackgroundColor(_ref2) {
  var themeMode = _ref2.themeMode;
  return modalTheme.backgroundColor(themeMode);
}
export function getBodyGutter(_ref3) {
  var themeMode = _ref3.themeMode;
  return modalTheme.bodyGutter(themeMode);
}
export function getBorderRadius(_ref4) {
  var themeMode = _ref4.themeMode,
    heightValue = _ref4.heightValue;
  // if modal is fullscreen, don't round the corners
  return heightValue === "100vh" ? "0px" : modalTheme.borderRadius(themeMode);
}
export function getBoxShadow(_ref5) {
  var themeMode = _ref5.themeMode;
  return modalTheme.boxShadow(themeMode);
}
export function getColor(_ref6) {
  var themeMode = _ref6.themeMode;
  return modalTheme.color(themeMode);
}
//# sourceMappingURL=modalTheme.js.map